import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, ChevronDown } from 'lucide-react';

/**
 * QuickAnswerSection - AIO optimized quick answer block
 * Collapsible section, starts collapsed
 */
export const QuickAnswerSection = ({ answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section className="py-8 px-4">
      <div
        className="max-w-4xl mx-auto glass rounded-2xl p-6 md:p-8"
        style={{ boxShadow: 'var(--shadow-glass)' }}
      >
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between gap-4 text-left"
        >
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-primary" />
              </div>
            </div>
            <h2 className="text-xl font-bold text-white">What is XtreamGate?</h2>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-primary transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
          />
        </button>

        <AnimatePresence>
          {isExpanded && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <p className="text-white/70 leading-relaxed mt-4 pl-16">
                {answer}
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};
